'use client';

import React from 'react';
import { FiboSearchType, TaxonomyType } from '@skin-seoul/service';
import type { FiboCollectionComboboxItem } from '@skin-seoul/service';
import { Image, Text } from '@skin-seoul/design-system';
import { extractImageSrc } from '@/components/fibosearch/FibosearchCombobox/utils';
import { BrandItem, ProductItem } from './Items';
import { HighlightedText } from './HighlightedText';
import NextImage from 'next/image';
import { useSafeRouter } from '@/hooks/useSafeRouter';
import { isEmpty } from 'es-toolkit/compat';
export type RenderItemProps = {
  item: FiboCollectionComboboxItem;
  inputValue: string;
};
export const RenderItem = ({
  item,
  inputValue
}: RenderItemProps) => {
  const router = useSafeRouter();

  // Render based on item type instead of groupType
  if (item.type === FiboSearchType.TAXONOMY) {
    const isProductCategory = item.taxonomy === TaxonomyType.PRODUCT_CATEGORY;
    return <BrandItem item={item} onClick={() => router.push(item.url)}>
        <HighlightedText value={item.label} match={inputValue} />
        {isProductCategory && !isEmpty(item.breadcrumbs) && <Text textStyle="label.small" color="neutral.600">
            in {item.breadcrumbs}
          </Text>}
      </BrandItem>;
  }
  if (item.type === FiboSearchType.PRODUCT) {
    return <ProductItem item={item} onClick={() => router.push(item.url)}>
        <Image alt={item.label} asChild border="1px solid" borderColor="neutral.100" borderRadius="4px" padding="4px" backgroundColor="white">
          <NextImage src={extractImageSrc(item.thumbHtml)} alt={item.label} width={44} height={44} />
        </Image>

        <HighlightedText value={item.label} match={inputValue} />
      </ProductItem>;
  }
  return null;
};